import {useQueryClient} from '@tanstack/react-query';
import {useApiMutation} from './api';
import {
  CreateIntentModel,
  CreateIntentSource,
  DeleteIntentSource,
  SaveIntentModel,
  EditIntentSource,
} from '../../shared/api/definitions/intent';
import {MetadataQueryKey} from '../../context/MetadataContext';

export function useCreateIntentSource() {
  const queryClient = useQueryClient();
  return useApiMutation(CreateIntentSource, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [MetadataQueryKey],
      });
    },
  });
}

export function useEditIntentSource() {
  const queryClient = useQueryClient();
  return useApiMutation(EditIntentSource, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [MetadataQueryKey],
      });
    },
  });
}

export function useDeleteIntentSource() {
  const queryClient = useQueryClient();
  return useApiMutation(DeleteIntentSource, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [MetadataQueryKey],
      });
    },
  });
}

export function useCreateIntentModel() {
  const queryClient = useQueryClient();
  return useApiMutation(CreateIntentModel, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [MetadataQueryKey],
      });
    },
  });
}

export function useSaveIntentModel() {
  const queryClient = useQueryClient();
  return useApiMutation(SaveIntentModel, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [MetadataQueryKey],
      });
    },
  });
}
